(function () {

    'use strict';

    angular.module('iplusjs.validator.navigation', [
        'lodash',
        'iplusjs.navigation',
        'iplusjs.loadingIndicator',
        'iplusjs.utils.formField'
    ])
        .directive('iplusjsNavigationValidator', navigationValidator);

    navigationValidator.$inject = [
        '$timeout',
        'lodash',
        'NavigationService',
        'LoadingIndicatorService',
        'FormFieldUtilsService'
    ];
    function navigationValidator($timeout, _, NavigationService, LoadingIndicatorService, FormFieldUtilsService) {
        return {
            restrict: 'A',
            link: function ($scope, $elem, $attrs) {
                var form = _.get($scope, $attrs.name),
                    pendingListener;

                form.submitHandlerHasRun = false;

                $scope.$watch($attrs.name + '.$valid', function (valid) {
                    NavigationService.getActive().valid = valid;
                    NavigationService.getNext().disabled = false;

                    if (!_.isUndefined(valid) && !valid) {
                        NavigationService.setFollowingDisabled(true);
                    }
                });

                $scope.$watch($attrs.name + '.$dirty', function (dirty) {
                    if (!_.isUndefined(dirty) && dirty === true) {
                        NavigationService.setFollowingDisabled(true);
                    }
                });

                $elem.bind('submit', function (event) {
                    form.$setSubmitted();
                    form.submitHandlerHasRun = false;
                    if (!_.isEmpty(form.$pending)) {
                        pendingListener = $scope.$watch(function () {
                            return form.$pending;
                        }, function (pending) {
                            if (!pending && (form.$submitted || form.isSubmitted)) {
                                pendingListener();
                                $timeout(function () {
                                    if (!$attrs.ngSubmit) {
                                        if (form.$valid) {
                                            NavigationService.goToStep($attrs.uiSref, {
                                                formValidation: true,
                                                ignoreFollowingCheck: true
                                            });
                                        }
                                    } else {
                                        form.submitHandlerHasRun = true;
                                        $scope.$eval($attrs.ngSubmit, { $event: event });
                                    }
                                });
                            }
                        });
                    } else {
                        if (!$attrs.ngSubmit) {
                            $timeout(function () {
                                if (_.isUndefined(form.$valid)) {
                                    form.$setValidity('_temp', true);
                                }

                                if (form.$valid) {
                                    NavigationService.goToStep($attrs.uiSref, {
                                        formValidation: true,
                                        ignoreFollowingCheck: true
                                    });
                                }
                            });
                        } else {
                            form.submitHandlerHasRun = true;
                        }
                    }
                });

                $scope.$on('$stateChangeStart', function (event, toState, toParams, fromState, fromParams) {
                    var isNavigationStepEnabled;

                    toParams = toParams || {};
                    if (!form.submitHandlerHasRun && $attrs.ngSubmit && !NavigationService.isPrevious(toState.name, fromState.name) && toParams.ignoreFollowingCheck !== true && toState.name !== fromState.name) {
                        event.preventDefault();
                        form.submitHandlerHasRun = true;

                        $timeout(function () {
                            FormFieldUtilsService.validate($scope.$eval($attrs.name), '$$controls', {
                                setTouched: true,
                                setIsSubmitted: true
                            });

                            $timeout(function () {
                                event.fromState = fromState;
                                event.toState = toState;
                                event.toParams = toParams;

                                $scope.$eval($attrs.ngSubmit, { $event: event });
                            });
                        });

                        return;
                    }

                    form.submitHandlerHasRun = false;
                    if (form && !form.$submitted && _.isFunction(form.$setSubmitted) && !NavigationService.isPrevious(toState.name, fromState.name)) {
                        form.$setSubmitted();
                    }

                    isNavigationStepEnabled = NavigationService.isNavigationStepEnabled(toState.name, fromState.name, form, toParams);

                    if (!isNavigationStepEnabled) {
                        LoadingIndicatorService.removeInProgress();
                        form.submitHandlerHasRun = false;
                        event.preventDefault();
                    }

                    return;
                });

                $scope.$on('$stateChangeSuccess', function () {
                    form.submitHandlerHasRun = false;
                });

                $scope.$on('$stateChangeError', function () {
                    form.submitHandlerHasRun = false;
                });

                $scope.$on('$stateChangeCancel', function () {
                    form.submitHandlerHasRun = false;
                });
            }
        };
    }
})();
